<template>
  <section class="visao-geral">
    <div v-if="carregando" class="vg-estado">Carregando…</div>
    <div v-else-if="erro" class="vg-estado vg-estado--erro">{{ erro }}</div>

    <div v-else-if="dados" class="vg-corpo">
      <!-- ================= cards ================= -->
      <div v-if="!apenasEmpresas" class="vg-cards">
        <div class="kpi-card">
          <div class="kpi-faixa" :style="{ background: cor.tecnico }"></div>
          <div class="kpi-body">
            <div class="kpi-head">
              <span class="kpi-label">Técnico</span>
              <i class="fa fa-wrench" :style="{ color: cor.tecnico }" aria-hidden="true"></i>
            </div>
            <div class="kpi-value">{{ formatarNumero(totais.colaboradoresTecnico) }}</div>
            <div class="kpi-foot">
              <span class="kpi-hint kpi-hint--forte">{{ unidadePessoas(totais.colaboradoresTecnico) }}</span>
              <span class="kpi-hint">{{ hintDespesas(totais.pendentesTecnico) }} · {{ formatarMoeda(totais.valorTecnico, moedaDaEmpresaCorrente()) }}</span>
            </div>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-faixa" :style="{ background: cor.coordenador }"></div>
          <div class="kpi-body">
            <div class="kpi-head">
              <span class="kpi-label">Coordenador</span>
              <i class="fa fa-user" :style="{ color: cor.coordenador }" aria-hidden="true"></i>
            </div>
            <div class="kpi-value">{{ formatarNumero(totais.colaboradoresCoordenador) }}</div>
            <div class="kpi-foot">
              <span class="kpi-hint kpi-hint--forte">{{ unidadePessoas(totais.colaboradoresCoordenador) }}</span>
              <span class="kpi-hint">{{ hintDespesas(totais.pendentesCoordenador) }} · {{ formatarMoeda(totais.valorCoordenador, moedaDaEmpresaCorrente()) }}</span>
            </div>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-faixa" :style="{ background: cor.aprovador }"></div>
          <div class="kpi-body">
            <div class="kpi-head">
              <span class="kpi-label">{{ cfg.nomeAprovador }}</span>
              <i class="fa fa-truck" :style="{ color: cor.aprovador }" aria-hidden="true"></i>
            </div>
            <div class="kpi-value">{{ formatarNumero(totais.colaboradoresAprovador) }}</div>
            <div class="kpi-foot">
              <span class="kpi-hint kpi-hint--forte">{{ unidadePessoas(totais.colaboradoresAprovador) }}</span>
              <span class="kpi-hint">{{ hintDespesas(totais.pendentesAprovador) }} · {{ formatarMoeda(totais.valorAprovador, moedaDaEmpresaCorrente()) }}</span>
            </div>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-faixa" :style="{ background: cor.diretoria }"></div>
          <div class="kpi-body">
            <div class="kpi-head">
              <span class="kpi-label">Diretoria</span>
              <i class="fa fa-bar-chart" :style="{ color: cor.diretoria }" aria-hidden="true"></i>
            </div>
            <div class="kpi-value">{{ formatarNumero(totais.colaboradoresDiretoria) }}</div>
            <div class="kpi-foot">
              <span class="kpi-hint kpi-hint--forte">{{ unidadePessoas(totais.colaboradoresDiretoria) }}</span>
              <span class="kpi-hint">{{ hintDespesas(totais.pendentesDiretoria) }} · {{ formatarMoeda(totais.valorDiretoria, moedaDaEmpresaCorrente()) }}</span>
            </div>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-faixa" :style="{ background: cor.vencidas }"></div>
          <div class="kpi-body">
            <div class="kpi-head">
              <span class="kpi-label">Vencidos</span>
              <i class="fa fa-exclamation-circle" :style="{ color: cor.vencidas }" aria-hidden="true"></i>
            </div>
            <div class="kpi-value">{{ formatarNumero(totais.colaboradoresVencidos) }}</div>
            <div class="kpi-foot">
              <span class="kpi-hint kpi-hint--forte">de {{ formatarNumero(totais.colaboradoresTotal) }} na fila · +{{ dados.diasParaVencer }} dias</span>
              <span class="kpi-hint">{{ hintDespesas(totais.vencidas) }}</span>
            </div>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-faixa" :style="{ background: cor.ano }"></div>
          <div class="kpi-body">
            <div class="kpi-head">
              <span class="kpi-label">Gasto no ano</span>
              <i class="fa fa-money" :style="{ color: cor.ano }" aria-hidden="true"></i>
            </div>
            <div class="kpi-value kpi-value--moeda">
              {{ formatarMoeda(totais.gastoAnoValor, moedaDaEmpresaCorrente()) }}
            </div>
            <div class="kpi-foot">
              <span v-if="gastoDeltaAbs !== null"
                    class="kpi-delta"
                    :class="gastoCaiu ? 'kpi-delta--up' : 'kpi-delta--down'">
                <span v-if="gastoCaiu">&#8595;</span><span v-else>&#8593;</span>
                {{ gastoDeltaAbs }}%
              </span>
              <span class="kpi-hint">{{ formatarNumero(totais.gastoAnoQuantidade) }} aprovadas</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ================= 1 · empresas em row/col ================= -->
      <div class="vg-painel" :class="{ 'vg-painel--largo': !apenasEmpresas }">
        <h3 class="vg-h3--toggle" role="button" tabindex="0"
            :aria-expanded="String(aberto('empresas'))"
            @click="alternar('empresas')" @keydown.enter.prevent="alternar('empresas')"
            @keydown.space.prevent="alternar('empresas')">
          <span class="vg-h3-txt">{{ apenasEmpresas ? 'Status Despesas por Empresa' : '1 · Status Despesas por Empresa' }}</span>
          <span v-if="!aberto('empresas')" class="vg-h3-resumo">
            {{ formatarNumero(totais.colaboradoresTotal) }} aqui · {{ formatarNumero(totais.colaboradoresOutrasEmpresas) }} fora · {{ empresas.length }} empresa(s)
          </span>
          <i class="fas" :class="aberto('empresas') ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
        </h3>
        <b-collapse :visible="aberto('empresas')">
        <div class="vg-painel-corpo">
          <!-- grid do Bootstrap 4 que ja esta no bundle: 12 colunas, blocos de 3 (4 por linha) -->
          <div class="row">
            <div v-for="e in empresas" :key="e.empresaId" class="col-12 col-sm-6 col-lg-3 vg-col">
              <component :is="e.ehEmpresaCorrente ? 'div' : 'a'"
                         class="vg-emp"
                         :class="{ 'vg-emp--atual': e.ehEmpresaCorrente }"
                         :href="e.ehEmpresaCorrente ? null : 'javascript:void(0)'"
                         :title="e.ehEmpresaCorrente ? null : 'Abrir nova aba em ' + e.nome"
                         @click="abrirEmpresa(e)">
                <div class="vg-emp-topo">
                  <span class="vg-emp-nome">{{ e.codigoZ }} — {{ e.nome }}</span>
                  <span class="vg-emp-qtd">{{ formatarNumero(e.colaboradoresTotal) }}</span>
                </div>
                <div class="vg-emp-status">
                  <button v-for="st in statusDaEmpresa(e)" :key="st.chave"
                          type="button"
                          class="vg-tag"
                          :class="{ 'vg-tag--fixa': st.status === null }"
                          :style="{ '--c': st.cor }"
                          :title="st.titulo"
                          :disabled="st.status === null"
                          @click="abrirStatus(e, st, $event)">
                    {{ st.sigla }} {{ st.n }}
                  </button>
                </div>
              </component>
            </div>
          </div>
          <p class="vg-nota">
            Cada número é um <b>colaborador parado</b> — a mesma unidade da grid abaixo, que lista uma
            linha por pessoa. As siglas são os estágios da fila; passe o mouse para ver o nome e
            quantas despesas são. Quem está parado em dois estágios aparece nos dois, então as siglas
            podem somar mais que o número da empresa.
          </p>
          <p v-if="outrasEmpresas.length" class="vg-nota">
            Cartões em fundo creme são <b>outras empresas</b>. Clicar no cartão <b>troca para aquela
            empresa nesta mesma tela</b> e traz tudo; clicar na sigla troca <b>e já filtra</b> por
            aquele estágio. <b>VENC</b> é corte de tempo, não estágio — informa e não filtra.
          </p>
          <p v-else class="vg-nota">Nenhuma outra empresa com pendência aparece para o seu perfil.</p>
        </div>
        </b-collapse>
      </div>

      <!-- ================= painéis ================= -->
      <div v-if="!apenasEmpresas" class="vg-tri">
        <!-- 1 -->
        <div class="vg-painel">
          <h3 class="vg-h3--toggle" role="button" tabindex="0"
              :aria-expanded="String(aberto('status'))"
              @click="alternar('status')" @keydown.enter.prevent="alternar('status')"
              @keydown.space.prevent="alternar('status')">
            <span class="vg-h3-txt">2 · Colaboradores parados por status</span>
            <span v-if="!aberto('status')" class="vg-h3-resumo">{{ formatarNumero(totais.colaboradoresTotal) }} parado(s)</span>
            <i class="fas" :class="aberto('status') ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
          </h3>
          <b-collapse :visible="aberto('status')">
          <div class="vg-painel-corpo">
            <div class="vg-donut-linha">
              <svg width="132" height="132" viewBox="0 0 42 42" role="img"
                   :aria-label="formatarNumero(totais.colaboradoresTotal) + ' colaboradores parados por status'">
                <circle cx="21" cy="21" r="15.9" fill="none" stroke="#eef1f4" stroke-width="7"></circle>
                <circle v-for="f in fatias" :key="f.status"
                        cx="21" cy="21" r="15.9" fill="none" stroke-width="7"
                        :stroke="f.cor" :stroke-dasharray="f.dash" :stroke-dashoffset="f.offset"></circle>
                <text x="21" y="20.2" text-anchor="middle" font-size="6.4" font-weight="700" fill="#1A1818">
                  {{ formatarNumero(totais.colaboradoresTotal) }}
                </text>
                <text x="21" y="25.4" text-anchor="middle" font-size="3.4" fill="#747474">colaboradores</text>
              </svg>
              <ul class="vg-legenda">
                <li v-for="f in fatias" :key="'l' + f.status">
                  <span class="vg-dot" :style="{ background: f.cor }"></span>
                  <span class="vg-lbl">{{ rotuloCurto(f.rotulo) }}</span>
                  <span class="vg-val">{{ formatarNumero(f.colaboradores) }}</span>
                  <span class="vg-pct">{{ f.pct.toFixed(1) }}%</span>
                </li>
              </ul>
            </div>

            <div class="vg-resumo">
              <div><span>Colaboradores parados nesta empresa</span><b>{{ formatarNumero(totais.colaboradoresTotal) }}</b></div>
              <div v-if="totais.colaboradoresOutrasEmpresas > 0" class="vg-resumo-fora">
                <span>Parados em outras empresas</span><span>{{ formatarNumero(totais.colaboradoresOutrasEmpresas) }}</span>
              </div>
              <div class="vg-resumo-tot"><span>Total no sistema</span><b>{{ formatarNumero(totalNoSistema) }}</b></div>
              <div class="vg-resumo-sub">
                <span>Despesas dessas pessoas</span>
                <span>{{ formatarNumero(totais.pendentesTotal) }} aqui · {{ formatarNumero(totais.pendentesOutrasEmpresas) }} fora</span>
              </div>
            </div>
          </div>
          </b-collapse>
        </div>

        <!-- 3 -->
        <div class="vg-painel">
          <h3 class="vg-h3--toggle" role="button" tabindex="0"
              :aria-expanded="String(aberto('gasto'))"
              @click="alternar('gasto')" @keydown.enter.prevent="alternar('gasto')"
              @keydown.space.prevent="alternar('gasto')">
            <span class="vg-h3-txt">3 · Valor gasto no ano por empresa</span>
            <span v-if="!aberto('gasto')" class="vg-h3-resumo">{{ gastoPorMoeda.length }} moeda(s)</span>
            <i class="fas" :class="aberto('gasto') ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
          </h3>
          <b-collapse :visible="aberto('gasto')">
          <div class="vg-painel-corpo">
            <div v-for="grupo in gastoPorMoeda" :key="grupo.localidade" class="vg-moeda">
              <h4>{{ grupo.moeda === 'CLP' ? 'Peso chileno (CLP)' : 'Real (BRL)' }} — {{ grupo.quantidadeEmpresas }} empresa(s)</h4>
              <table class="vg-tabela">
                <tbody>
                  <tr v-for="e in grupo.empresas" :key="e.empresaId" :class="{ 'linha-fora': !e.ehEmpresaCorrente }">
                    <td><b v-if="e.ehEmpresaCorrente">{{ e.codigoZ }} — {{ e.nome }}</b>
                        <span v-else>{{ e.codigoZ }} — {{ e.nome }}</span></td>
                    <td class="n">{{ formatarMoeda(e.valor, grupo.moeda) }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="vg-moeda-tot">
                <span>Total {{ grupo.moeda }}</span><span>{{ formatarMoeda(grupo.total, grupo.moeda) }}</span>
              </div>
            </div>
            <p class="vg-nota">
              Cada moeda tem seu próprio total — valores de moedas diferentes não são somados.
            </p>
          </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import VisaoGeralDespesas from './VisaoGeralDespesas'
export default VisaoGeralDespesas
</script>

<style scoped>
.visao-geral { margin-bottom: 14px; }
.vg-corpo { padding: 0; }
.vg-estado { padding: 20px 16px; font-size: 13px; color: #747474; }
.vg-estado--erro { color: #B60000; }

.vg-cards { display: grid; grid-template-columns: repeat(auto-fit, minmax(196px, 1fr)); gap: 12px; }
/* padrão <KpiCard> da Vitrine: card branco, faixa do departamento no topo, número 26px tabular */
.kpi-card { background: #fff; border: 1px solid #e3e6ea; border-radius: 6px; overflow: hidden;
  min-height: 104px; transition: box-shadow 150ms ease-out; }
.kpi-card:hover { box-shadow: 0 2px 10px rgba(0,0,0,.09); }
.kpi-faixa { height: 4px; }
.kpi-body { padding: 12px 16px 10px; }
.kpi-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.kpi-label { font-size: 11px; font-weight: 700; letter-spacing: .4px; text-transform: uppercase; color: #747474; }
.kpi-value { font-size: 26px; font-weight: 700; line-height: 1.1; margin-top: 4px; color: #1A1818;
  font-variant-numeric: tabular-nums; overflow-wrap: anywhere; min-width: 0; }
.kpi-value--moeda { font-size: 21px; }
.kpi-foot { display: flex; align-items: center; gap: 7px; margin-top: 3px; flex-wrap: wrap; }
.kpi-hint { font-size: 11.5px; color: #747474; }
/* a unidade do numero grande (colaborador) fica em cima e mais forte que a contagem de
   despesa, que e o detalhe — foi a leitura invertida que confundiu na revisao de 02/09 */
.kpi-hint--forte { color: #4a4a4a; font-weight: 600; }
.kpi-delta { display: inline-flex; align-items: center; gap: 2px; font-size: 12px; font-weight: 600; }
.kpi-delta--up { color: #008144; }
.kpi-delta--down { color: #B60000; }

.vg-tri { display: grid; grid-template-columns: 1fr 1.3fr; gap: 14px; margin-top: 14px; }
@media (max-width: 1200px) { .vg-tri { grid-template-columns: 1fr; } }
.vg-painel { background: #fff; border: 1px solid #e3e6ea; border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .05); }
.vg-painel h3 { margin: 0; font-size: 12.5px; letter-spacing: .5px; text-transform: uppercase;
  padding: 11px 14px; border-bottom: 1px solid #e3e6ea; color: #1A1818; }
/* header do painel vira o proprio botao de recolher, no padrao do collapseApr da casa
   (chevron fa-angle-down/up). Recolhido, o resumo a direita diz o que esta escondido. */
.vg-h3--toggle { display: flex; align-items: center; gap: 10px; cursor: pointer;
  user-select: none; }
.vg-h3--toggle:hover { background: #FAFAFA; }
.vg-h3--toggle:focus-visible { outline: 2px solid #024D2A; outline-offset: -2px; }
.vg-h3-txt { flex: 1; }
.vg-h3-resumo { font-size: 11.5px; text-transform: none; letter-spacing: 0; color: #747474;
  font-variant-numeric: tabular-nums; }
.vg-h3--toggle .fas { color: #747474; font-size: 14px; }
.vg-painel-corpo { padding: 14px; }

.vg-donut-linha { display: flex; align-items: center; gap: 18px; }
.vg-legenda { list-style: none; margin: 0; padding: 0; font-size: 13px; flex: 1; }
.vg-legenda li { display: flex; align-items: center; gap: 8px; padding: 5px 0; }
.vg-dot { width: 11px; height: 11px; border-radius: 50%; flex: 0 0 auto; }
.vg-lbl { flex: 1; }
.vg-val { font-variant-numeric: tabular-nums; font-weight: 600; }
.vg-pct { color: #747474; font-size: 12px; min-width: 46px; text-align: right; }

.vg-resumo { margin-top: 12px; padding: 10px 12px; background: #FAFAFA; border: 1px solid #e3e6ea;
  border-radius: 5px; font-size: 12.5px; }
.vg-resumo div { display: flex; justify-content: space-between; padding: 3px 0; }
.vg-resumo-fora { color: #7a5200; font-weight: 700; }
.vg-resumo-tot { padding: 7px 0 2px; border-top: 1px solid #e3e6ea; margin-top: 4px; }
.vg-resumo-sub { font-size: 11.5px; color: #8a8a8a; border-top: 1px dashed #e3e6ea;
                 margin-top: 4px; padding-top: 6px; }

/* ---- 1 · empresas em row/col do Bootstrap 4 (12 colunas, blocos de 3) ---- */
.vg-painel--largo { margin-top: 14px; }
.vg-col { margin-bottom: 10px; }
.vg-emp { display: block; border: 1px solid #e3e6ea; border-radius: 5px; padding: 8px 10px;
  background: #fff; text-decoration: none; color: inherit; height: 100%; }
a.vg-emp:hover, a.vg-emp:focus { border-color: #024D2A; box-shadow: 0 1px 4px rgba(0,0,0,.09);
  text-decoration: none; color: inherit; outline-offset: 2px; }
.vg-emp:not(.vg-emp--atual) { background: #fffdf5; }
.vg-emp--atual { border-color: #024D2A; border-left-width: 3px; }
.vg-emp-topo { display: flex; align-items: baseline; gap: 8px; }
.vg-emp-nome { flex: 1; font-size: 12.5px; font-weight: 600; overflow: hidden;
  text-overflow: ellipsis; white-space: nowrap; }
.vg-emp-qtd { font-size: 19px; font-weight: 700; font-variant-numeric: tabular-nums; line-height: 1; }
.vg-emp-status { display: flex; flex-wrap: wrap; gap: 4px; margin-top: 6px; }
/* sigla minimalista: so a cor do estagio na borda, sem virar um bloco de cor */
.vg-tag { font-size: 10.5px; font-weight: 700; font-variant-numeric: tabular-nums;
  padding: 1px 5px; border-radius: 3px; color: var(--c); border: 1px solid var(--c);
  background: #fff; line-height: 1.5; white-space: nowrap; cursor: pointer; }
.vg-tag:hover:not(:disabled), .vg-tag:focus:not(:disabled) { background: var(--c); color: #fff;
  outline-offset: 1px; }
/* VENC nao e status do enum, e corte de tempo: nao filtra, entao nao finge ser clicavel */
.vg-tag--fixa, .vg-tag:disabled { cursor: default; opacity: 1; }
.vg-emp:not(.vg-emp--atual) .vg-tag { background: rgba(255,255,255,.75); }

.vg-tabela { width: 100%; border-collapse: collapse; font-size: 12.5px; }
.vg-tabela th { text-align: left; font-size: 10.5px; text-transform: uppercase; color: #747474;
  font-weight: 600; padding: 6px; border-bottom: 1px solid #e3e6ea; }
.vg-tabela td { padding: 6px; border-bottom: 1px solid #F1F1F1; white-space: nowrap; }
.vg-tabela td:first-child { max-width: 190px; overflow: hidden; text-overflow: ellipsis; }
.vg-tabela tr:last-child td { border-bottom: none; }
.vg-tabela .n { text-align: right; font-variant-numeric: tabular-nums; }
.vg-tabela tr.linha-fora td { background: #fffdf5; }
.vg-pill { display: inline-block; min-width: 24px; text-align: center; padding: 1px 6px;
  border-radius: 10px; font-size: 11.5px; font-weight: 700; color: #fff; }
.vg-vazio { color: #C9C9C9; }
.vg-pessoas { color: #747474; font-weight: 600; }
.vg-atual { font-weight: 700; }
.vg-badge { font-size: 10px; background: #e8f3ec; color: #024D2A; border: 1px solid #cfe6d8;
  padding: 1px 6px; border-radius: 9px; margin-left: 6px; }
.vg-link { color: #007bff; text-decoration: none; border-bottom: 1px dotted #007bff; }
.vg-link:hover, .vg-link:focus { color: #024D2A; border-bottom-style: solid; outline-offset: 2px; }

.vg-moeda { border: 1px solid #e3e6ea; border-radius: 5px; margin-bottom: 10px; }
.vg-moeda:last-of-type { margin-bottom: 0; }
.vg-moeda h4 { margin: 0; font-size: 11px; text-transform: uppercase; color: #747474;
  padding: 7px 10px; background: #FAFAFA; border-bottom: 1px solid #e3e6ea; }
.vg-moeda-tot { padding: 8px 10px; font-size: 12.5px; display: flex; justify-content: space-between;
  border-top: 1px solid #e3e6ea; background: #FAFAFA; font-weight: 700; }

.vg-nota { margin: 12px 0 0; font-size: 12px; color: #747474; }
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelexpensezpag/components/VisaoGeralDespesas/VisaoGeralDespesas.vue